export class StringUtils {

    static escapeAccents(text) {
        // https://stackoverflow.com/a/37511463
        return text.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
    }

    /**
     * Para búsquedas genéricas, no tiene en cuenta los acentos ni las mayúsculas.
     * @param text
     * @param key
     * @returns {*}
     */
    static compareStringsForSearch(text, key) {
        return StringUtils.escapeAccents(text.toLowerCase()).includes(key.toLowerCase());
    }

    static hasAnyNumber(text) {
        return /\d/.test(text);
    }
}